import { useApp } from '../lib/data/store';
import { useNav } from '../lib/nav';

/** Always-visible reassurance strip: online state, queued-for-sync count, today's pace. */
export function StatusStrip() {
  const { online, queued, todayDone, todayPerHour } = useApp();
  const { setTab } = useNav();
  return (
    <div className="statusstrip">
      <span className={`net ${online ? 'on' : 'off'}`}>
        <span className="dot" />
        {online ? 'Online' : 'Offline — data saved'}
      </span>
      <span className="sep">·</span>
      <span className={`queued ${queued > 0 ? 'has' : ''}`}>
        {queued > 0 ? `${queued} to sync` : 'All synced'}
      </span>
      <span className="today">
        {todayDone} today{todayPerHour > 0 ? ` · ${todayPerHour}/hr` : ''}
      </span>
      <button
        aria-label="Profile and settings"
        onClick={() => setTab('profile')}
        style={{
          background: 'none',
          border: 0,
          color: 'inherit',
          fontSize: 20,
          cursor: 'pointer',
          minWidth: 44,
          minHeight: 44,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        ⚙️
      </button>
    </div>
  );
}
